import { render, staticRenderFns } from "./TariffGrid.vue?vue&type=template&id=24d16db9"
import script from "./TariffGrid.vue?vue&type=script&lang=ts"
export * from "./TariffGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports